<div class="g-modal-v2 update-name-modal">
  <div class="g-modal-v2-header">
    <div class="g-modal-v2-title">
      {{ 'update_name_modal.title' | translate }}
    </div>

    <button
      class="g-modal-v2-close"
      (click)="dialogRef.close({ type: state() === 'success' ? 'CONFIRM' : 'CANCEL' })"
    >
      <tc-icon name="close" />
    </button>
  </div>

  <form
    class="g-modal-v2-content"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    @if (state() === 'input') {
      <div class="g-form-control">
        <label
          class="g-form-label"
          for="last-name"
        >
          {{ 'global.last_name' | translate }}
        </label>

        <input
          class="g-form-input"
          [class.g-form-input-invalid]="isControlInvalid(form.controls.lastName)"
          [formControl]="form.controls.lastName"
          type="text"
          id="last-name"
          placeholder="Шевченко"
          appAutofocus
        >

        @if (isControlInvalid(form.controls.lastName)) {
          <div class="g-form-control-error">
            {{ 'global.required_field' | translate }}
          </div>
        }
      </div>

      <div class="form-controls-row">
        <div class="g-form-control">
          <label
            class="g-form-label"
            for="first-name"
          >
            {{ 'global.name' | translate }}
          </label>

          <input
            class="g-form-input"
            [class.g-form-input-invalid]="isControlInvalid(form.controls.firstName)"
            [formControl]="form.controls.firstName"
            type="text"
            id="first-name"
            placeholder="Тарас"
          >

          @if (isControlInvalid(form.controls.firstName)) {
            <div class="g-form-control-error">
              {{ 'global.required_field' | translate }}
            </div>
          }
        </div>

        <div class="g-form-control">
          <label
            class="g-form-label"
            for="middle-name"
          >
            {{ 'global.parent_name' | translate }}
          </label>

          <input
            class="g-form-input"
            [class.g-form-input-invalid]="isControlInvalid(form.controls.middleName)"
            [formControl]="form.controls.middleName"
            type="text"
            id="middle-name"
            placeholder="Григорович"
          >

          @if (isControlInvalid(form.controls.middleName)) {
            <div class="g-form-control-error">
              {{ 'global.required_field' | translate }}
            </div>
          }
        </div>
      </div>

      @if (error()) {
        <div class="g-form-error">
          {{ error() }}
        </div>
      }
    } @else {
      <div class="success-header">
        {{ 'update_name_modal.success_header' | translate }}
      </div>
      <div class="success-text g-html-description">
        {{ 'update_name_modal.success_text' | translate }}
      </div>
    }

    <tc-button
      class="update-full-name-modal-submit"
      [isLoading]="isLoading()"
      [isDisabled]="isSubmitDisabled()"
      buttonType="submit"
      buttonSize="large"
    >
      @if (state() === 'input') {
        {{ 'global.save' | translate }}
      } @else {
        {{ 'global.done' | translate }}
      }
    </tc-button>
  </form>
</div>
